module.exports = __webpack_public_path__ + "img/VFNetztesterFiber_128.847f4ffd.png";